export enum ChainId {
  SOLANA_DEVNET = 501423,
  SOLANA_MAINNET = 501424,
}